'use client';

import { useEffect, useState, type ComponentType } from 'react';
import type { AdSlotProps } from './AdSlot';
import { isLabPerformanceAgent, whenThirdPartyAllowed } from '@/lib/defer-third-party';

type AdSlotWrapperProps = AdSlotProps;

export default function AdSlotWrapper(props: AdSlotWrapperProps) {
  const [Slot, setSlot] = useState<ComponentType<AdSlotProps> | null>(null);

  useEffect(() => {
    if (isLabPerformanceAgent()) return;

    let cancelled = false;
    void whenThirdPartyAllowed({ fallbackMs: 3_500 })
      .then(() => import('./AdSlot'))
      .then((module) => {
        if (!cancelled) setSlot(() => module.AdSlot);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!Slot) return null;
  return <Slot {...props} />;
}
